import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import { Support } from "@/app/entities/Support";
import { optionsSupportSelect } from "@/app/utils/supportCategoryEnum";

import { SUPPORT_REQUESTS_CATEGORY } from "../useSupportController";

interface SearchHistoryProps {
  supports: Support[];
  handleMakeFetchAgain: (itemSearch: string) => void;
}

const categoryLabel = (category: string) =>
  category === SUPPORT_REQUESTS_CATEGORY
    ? "Chamados"
    : (optionsSupportSelect.find((option) => option.value === category)
        ?.label ?? category);

export function SearchHistory({
  supports,
  handleMakeFetchAgain,
}: SearchHistoryProps) {
  return (
    <div className="flex min-h-0 flex-col">
      <p className="pb-4 text-xs font-semibold uppercase tracking-wide text-black04">
        Histórico de pesquisa
      </p>

      <div className="space-y-3">
        {supports.length > 0 ? (
          supports.map((item) => (
            <button
              key={item._id}
              type="button"
              onClick={() => handleMakeFetchAgain(item.props.values[0])}
              className="flex w-full flex-col gap-1 rounded-lg border border-gray01 bg-gray-50 p-3 text-left transition-colors hover:bg-gray02"
            >
              <p className="text-xs text-black04">
                {format(new Date(item.createdAt), "dd/MM · HH:mm", {
                  locale: ptBR,
                })}
              </p>
              <p className="font-semibold text-black01">
                {item.props.values[0]}
              </p>
              {!!item.props.options.length && (
                <div className="flex flex-wrap gap-2">
                  {item.props.options.map((category) => (
                    <span
                      key={category}
                      className="w-fit rounded-sm border border-gray01 bg-gray02 px-1 py-[3px] text-[10px] font-medium text-gray-500"
                    >
                      {categoryLabel(category)}
                    </span>
                  ))}
                </div>
              )}
            </button>
          ))
        ) : (
          <p className="py-8 text-center text-sm text-black04">
            Não há histórico de pesquisa
          </p>
        )}
      </div>
    </div>
  );
}
